import React from "react";
import { Link } from 'react-router-dom';

const WorkCard = ({ id, workData,key }) => {
    return (
        <Link to={`/works/${id}`} className="work-card" key={key} onClick={() => sessionStorage.setItem('scrollPosition', window.scrollY)}> 
        <img src={workData.imageUrl} alt={workData.title} className="work-image" />
        <h5 className="work-format">{workData.format}</h5>
        <h3 className="work-title">{workData.title}</h3> 
      </Link>
    );
  };

  export default WorkCard;